import type { MutableRefObject } from 'react'
import { ActionType } from '@/store/slices/editor/actionTypes'
import { INDEXED_IMAGE_ACTIONS, type IndexedImage } from '@/utils/indexedImage'
import { customAmplitude } from '@/utils/customAmplitude'

type CreationPageCallback = {
  action?: ActionType
  analytic?: { source?: string; projectSizeId?: string }
} | null

/** Fire `Editor Open` at most once per editor mount. */
export function trackEditorOpenOnce(
  trackedRef: MutableRefObject<boolean>,
  properties: Record<string, unknown>,
): void {
  if (trackedRef.current) return
  trackedRef.current = true
  customAmplitude('Editor Open', properties)
}

export function getEditorOpenPropertiesForCreationEntry(
  callback: CreationPageCallback,
  indexedImage: IndexedImage | null,
): Record<string, unknown> {
  if (indexedImage?.action) {
    switch (indexedImage.action) {
      case INDEXED_IMAGE_ACTIONS.OPEN_EDITOR_BATCH:
        return { Source: 'Batch' }
      case INDEXED_IMAGE_ACTIONS.OPEN_EDITOR_PHOTOSHOOT:
        return { Source: 'Photoshoot' }
      case INDEXED_IMAGE_ACTIONS.OPEN_EDITOR_AI_FASHION_MODELS:
        return { Source: 'AI_models' }
      case INDEXED_IMAGE_ACTIONS.REMOVE_BG:
        return { Source: 'usecase.magic' }
      case INDEXED_IMAGE_ACTIONS.MAGIC_BG:
        return { Source: 'usecase.magicbg' }
      case INDEXED_IMAGE_ACTIONS.AI_RESTYLE:
        return { Source: 'usecase.restyle' }
    }
  }

  if (callback?.action == null) {
    return { Source: 'Direct' }
  }

  switch (callback.action) {
    case ActionType.CUSTOM_SIZE: {
      const properties: Record<string, unknown> = {
        Source: callback.analytic?.source ?? 'Direct',
      }
      if (callback.analytic?.projectSizeId != null) {
        properties['Project Size Id'] = callback.analytic.projectSizeId
      }
      return properties
    }
    case ActionType.ADD_IMAGE:
      return { Source: 'Photo' }
    case ActionType.REMOVE_BG:
      return { Source: 'usecase.magic' }
    case ActionType.REMOVE_OBJ:
      return { Source: 'usecase.remove' }
    case ActionType.ADD_TEMPLATE:
      return { Source: 'Template' }
    case ActionType.MAGIC_BACKGROUND:
      return { Source: 'usecase.magicbg' }
    case ActionType.ENHANCE:
      return { Source: 'usecase.enhance' }
    case ActionType.AI_STYLE:
      return { Source: 'usecase.restyle' }
    case ActionType.AI_FASHION_MODEL:
      return { Source: 'AI_models' }
    case ActionType.AI_IMAGE:
      return { Source: 'usecase.aiArt' }
    default:
      return { Source: 'Direct' }
  }
}
